export const apiConfig = {
	url: 'https://freshfisheshop-default-rtdb.europe-west1.firebasedatabase.app/',
};